/**
 * Institutional momentum is the mean of `signal_score`, stored on
 * tenant_account_scores as `momentum_12w`. Weekly `momentum_score_change`
 * rows are a different quantity and must not win when both exist.
 */

export function meanSignalScore(rows) {
  const scores = (Array.isArray(rows) ? rows : [])
    .map((s) => (s?.signal_score == null || s.signal_score === '' ? NaN : Number(s.signal_score)))
    .filter((n) => !Number.isNaN(n));
  if (!scores.length) return null;
  return scores.reduce((a, b) => a + b, 0) / scores.length;
}

export function resolveInstitutionalMomentum(rows, stored12w) {
  const stored = stored12w == null || stored12w === '' ? NaN : Number(stored12w);
  if (!Number.isNaN(stored)) return stored;
  return meanSignalScore(rows);
}

export function formatInstitutionalMomentum(n) {
  if (n == null || n === '' || Number.isNaN(Number(n))) return '—';
  const v = Number(n);
  const rounded = Math.round(v * 10) / 10;
  return rounded > 0 ? `+${rounded}` : String(rounded);
}
